"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var FeatureFlag_1 = __importDefault(require("@CommonFrontendBackend/FeatureFlag"));
var Types_1 = require("@CommonFrontendBackend/Projects/Types");
module.exports = function ($rootScope) {
    var usingFeature = $rootScope.di.get("usingFeature");
    var projectStatus = $rootScope.di.get("projectStatus");
    var isTemplate = $rootScope.di.get("isTemplate");
    var isPrintMode = $rootScope.di.get("isPrintMode");
    var isCollaboratorPage = $rootScope.di.get("isCollaboratorPage");
    return (usingFeature(FeatureFlag_1.default.ConsumerVirality) &&
        !usingFeature(FeatureFlag_1.default.RefreshedNavigationMenu) &&
        projectStatus !== Types_1.ProjectStatus.Draft &&
        !isTemplate &&
        !isPrintMode &&
        !isCollaboratorPage);
};
